module.exports = __webpack_public_path__ + "media/images/pages/img_culture_facility_01-68817939a41b9009a442dc4a0c9c2855.jpg";